(function () {
  function initSlider(root) {
    var handle = root.querySelector('.selora-before-after__handle');
    if (!handle) return;

    function setPosition(percentage) {
      percentage = Math.min(Math.max(percentage, 0), 100);
      root.style.setProperty('--selora-before-after-position', percentage + '%');
      handle.setAttribute('aria-valuenow', Math.round(percentage));
    }

    function calculatePosition(clientX) {
      var rect = root.getBoundingClientRect();
      setPosition(((clientX - rect.left) / rect.width) * 100);
    }

    function onPointerMove(event) {
      calculatePosition(event.clientX);
    }

    function onPointerUp() {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
    }

    root.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      calculatePosition(event.clientX);
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
    });

    handle.addEventListener('keydown', function (event) {
      var current = parseFloat(getComputedStyle(root).getPropertyValue('--selora-before-after-position'));
      if (isNaN(current)) current = 50;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setPosition(current - 2);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setPosition(current + 2);
      }
    });
  }

  document.querySelectorAll('.selora-before-after').forEach(initSlider);
})();
